import React from "react";
import { Box, CircularProgress } from "@mui/material";

const LoadingFallback = () => (
  <Box className="flex justify-center items-center min-h-screen">
    <CircularProgress size={40} />
  </Box>
);

export default React.memo(LoadingFallback);